const Caja = ({ history }) => {
  return <h2>Caja</h2>;
};

export default Caja;
